/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContextualInformationPopup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v20H2zm2 2v16h16V4z" />
        <path d="M18 8h-2V6h2zm-7 10H6v-2h5zm7 0h-5v-2h5zm0-6h-2v-2h2zM6 6h8v8H6zm2 2v4h4V8z" />
      </g>
    </g>
  </Icon>
);
export { SvgContextualInformationPopup as ContextualInformationPopup };
